import type { SearchCriteria } from '@awazevr/mfe-common.types-and-mocks.site-search-service'

/**
 * "View more" re-runs the CURRENT search with `useExpandedCoordinates=true`
 * added and `showExpandedResults` dropped, producing a standard, shareable
 * results page whose results are the expanded-polygon properties. On that page
 * the gate (`!useExpandedCoordinates`) hides the carousel and the view-more CTA.
 */
export const buildViewMoreHref = (searchCriteria: SearchCriteria): string => {
  const params = new URLSearchParams()

  Object.entries(searchCriteria).forEach(([key, value]) => {
    if (key === 'showExpandedResults' || key === 'useExpandedCoordinates') {
      return
    }

    if (value === undefined || value === null || value === '') {
      return
    }

    params.set(key, Array.isArray(value) ? value.join(',') : String(value))
  })

  params.set('useExpandedCoordinates', 'true')
  params.set('page', '1')

  return `/search?${params.toString()}`
}
